<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12" lg="10">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Ingresos</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( unidades  , 'unidades')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
            	<v-col cols="12" md="4">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechainicial"
                  type="date"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechafinal"
                  type="date"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center green--text" color="#d8ecc9">
	  		  				<div><b>Anticipos</b></div>
	  		  				<div class="text-h5"><b>{{ formatMoney( totalAnticipo ) }}</b></div>
	  		  			</v-card>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center red--text" color="#f9bebe">
	  		  				<div><b>Liquidación</b></div>
	  		  				<div class="text-h5"><b>{{ formatMoney( totalEgreso ) }}</b></div>
	  		  			</v-card>
	  		  		</v-col>

              <v-col cols="12" lg="3" md="4">
                <v-card class="shadowCard pa-4 text-center pink--text" color="#F48FB1">
                  <div><b>Inversión</b></div>
                  <div class="text-h5"><b>{{ formatMoney( totalEgresoInver ) }}</b></div>
                </v-card>
              </v-col>

	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center orange--text" color="#f7d48a">
	  		  				<div><b>Total</b></div>
	  		  				<div class="text-h5"><b>{{ formatMoney( totalIngreso ) }}</b></div>
	  		  			</v-card>
	  		  		</v-col>
	  		  	</v-row>

            <v-row>
              <v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="ingresosegresos"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.tipo="{ item }">
							      <v-chip 
							      	v-if="item.tipo == 1"
							      	small
							      	color="green"
							      	dark
							      	label
							      	outlined
							      >Ingreso</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      	label
							      	outlined
							      >Egreso</v-chip>
							    </template>

							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.monto="{ item }">
							      {{ formatMoney( item.monto ) }}
							    </template>
							  
							    <template v-slot:item.color="{ item }">
							    	<v-chip 
							    		:color="item.color"
							    		rounded
							    		small 
							    	>
							    	</v-chip>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="error" 
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idingresos_egresos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <label>Ingresa el nombre de la categoría</label>
          <v-text-field
            v-model="editedItem.detalle"
            label="* Detalle"
            filled
            dense
          ></v-text-field>

          <label>Ingresa el monto</label>
          <v-text-field
            v-model="editedItem.monto"
            label="* Monto"
            filled
            dense
            type="number"
          ></v-text-field>

          <label>Selecciona el tipo de Clacificación</label>
          <v-autocomplete
            filled
            dense
            clearable
            v-model="editedItem.idclasificacion"
            :items="clasificacion"
            label="Selecciona una Clacificación"
            persistent-hint
            hide-details
            item-text="clasificacion"
            item-value="idclasificacion"
          >
          </v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            small
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            dense
            small
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la clasificación?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],
    
    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idingresos_egresos:0,
				fecha_creacion:null,
				deleted:null,
				ingresosegresos:'',
				color: null
      },

      defaultItem: {
        idingresos_egresos:0,
				fecha_creacion:null,
				deleted:null,
				ingresosegresos:'',
				color: null
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      ingresosegresos: [],
      headers: [
        { text: 'ID'             , value: 'idingresos_egresos'  },
        { text: 'Detalle'        , value: 'detalle'    },
        { text: 'Monto'          , value: 'monto'       ,align: 'end'      },
        { text: 'Clasificación'  , value: 'clasificacion'            },
        { text: 'Tipo'           , value: 'tipo'            },
        { text: 'color'          , value: 'color'            },
        { text: 'Alta'           , value: 'fecha_creacion'   },
        { text: 'Actions'        , value: 'actions', sortable: false },
      ],

      clasificacion: [],

      fechainicial: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafinal: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar ingreso/egreso' : 'Editar el ingreso/egreso'
      },

      totalIngreso(  ){

    		return this.ingresosegresos.filter( el => el.tipo == 1 ).map( item => item.monto  ).reduce((prev, curr) => prev + curr, 0)

      },

			totalEgreso(  ){

    		return this.ingresosegresos.filter( el => el.idclasificacion == 6 ).map( item => item.monto  ).reduce((prev, curr) => prev + curr, 0)

			},

      totalEgresoInver ( ){

        return this.ingresosegresos.filter( el => el.idclasificacion == 16 ).map( item => item.monto  ).reduce((prev, curr) => prev + curr, 0)

      },

			totalAnticipo(  ){

    		return this.ingresosegresos.filter( el => el.idclasificacion == 5 ).map( item => item.monto  ).reduce((prev, curr) => prev + curr, 0)

			},

			totalGanancia(  ){

				return this.totalIngreso - this.totalEgreso
			},

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
      await this.getClasificacion()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.ingresosegresos = []
        const payload = {
        	fechainicial: this.fechainicial,
					fechafinal: this.fechafinal
        }
        return this.$http.post('ingresosegresos.list',payload).then(response=>{
        	this.ingresosegresos = response.body.filter( el => el.tipo == 1 )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getClasificacion () {
      	this.cargar = true
        this.clasificacion = []
        return this.$http.get('clasificacion.list').then(response=>{
        	this.clasificacion = response.body.filter( el => el.tipo == 1 )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.ingresosegresos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.ingresosegresos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('ingresosegresos.update/' + this.editedItem.idingresos_egresos, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('ingresosegresos.update/' + this.editedItem.idingresos_egresos, this.editedItem).then(response=>{
            this.close( )
          	this.validarSuccess( response.body.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('ingresosegresos.add', this.editedItem).then(response=>{
            this.close( )
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },

      formatMoney(value) {
        // Formateamos el número como moneda en dólares (USD)
        return value.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
      },
    },
  }
</script>


